import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import CreditApp from "./CreditApp";

function mapStateToProps({
    account: { integration_settings },
    creditApp: {
        base: { currentStep, done, breadcrumb, tabs },
    },
}: ApplicationStore) {
    const creditAppDealerId = integration_settings?.DI_Credit.dealer_id;
    return {
        breadcrumb,
        currentStep,
        done,
        tabs,
        creditAppDealerId,
    };
}

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CreditApp);
